import Swal from "sweetalert2";
import { IUsuarioHistoricoStatus, IUsuarios, IUsuariosPaginado } from "../interfaces/IUsuarios";
import api from './Api';

class UsuariosService {
    async obterTodos(funcaoSucesso?: (data: IUsuarios[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios[]>('Usuario');
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async obterTodosPorClienteID(clienteID: number, funcaoSucesso?: (data: IUsuarios[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios[]>('Usuario/BuscarPorClienteID/'+clienteID);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async obterPorId(id: number, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IUsuarios>(`Usuario/${id}`);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async criar(usuario: IUsuarios, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.post('Usuario', usuario);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async atualizar(usuario: IUsuarios, funcaoSucesso?: (data: IUsuarios) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`Usuario/${usuario.id}`, usuario);
    
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async listar(params: { page?: number; perPage?: number; q?: string; ativo?: boolean | null; clienteId?: number }): Promise<IUsuariosPaginado | null> {
        try {
            const query = new URLSearchParams();
            if (params.page) query.append('page', String(params.page));
            if (params.perPage) query.append('perPage', String(params.perPage));
            if (params.q) query.append('q', params.q);
            if (params.ativo !== null && params.ativo !== undefined) query.append('ativo', String(params.ativo));
            if (params.clienteId) query.append('clienteId', String(params.clienteId));

            const { data } = await api.get<IUsuariosPaginado>(`Usuario/listar?${query.toString()}`);
            return data;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return null;
        }
    }

    /** DEVN3-780: ativa ou inativa o usuário, com motivo opcional que vai para o histórico de status. */
    async alterarStatus(id: number, ativar: boolean, motivo?: string, funcaoSucesso?: () => void): Promise<boolean> {
        try {
            const { data } = await api.patch<{ message?: string }>(`Usuario/${id}/${ativar ? 'ativar' : 'inativar'}`, { motivo: motivo || null });
            funcaoSucesso && funcaoSucesso();
            Swal.fire({
                text: data?.message || (ativar ? 'Usuário ativado com sucesso.' : 'Usuário inativado com sucesso.'),
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message || 'Não foi possível alterar o status do usuário.',
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return false;
        }
    }

    async historicoStatus(id: number): Promise<IUsuarioHistoricoStatus[] | null> {
        try {
            const { data } = await api.get<IUsuarioHistoricoStatus[]>(`Usuario/${id}/historico-status`);
            return data;
        } catch (error: any) {
            Swal.fire({
                text: error.response?.data?.message || error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
            return null;
        }
    }
}


export default new UsuariosService();